import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment from '@flipster/utils/segment';
import { TpslEventCommonPayload, TradeEvent } from '@flipster/utils/segment/events/trade';

import { SymbolScope } from '../shared/symbol/bunja';
import { TpslTypeScope, tpslModalBunja } from './state';
import { parentPositionBunja } from './state/base';

export const tpslModalSegmentBunja = bunja(() => {
  const symbol = bunja.use(SymbolScope);
  const tpslType = bunja.use(TpslTypeScope);
  const { positionType, sideAtom, leverageAtom } = bunja.use(parentPositionBunja);
  const { isTimeTriggerOrder, isLimitOrder, tpslTabAtom } = bunja.use(tpslModalBunja);

  const commonEventPayloadAtom = atom<TpslEventCommonPayload>((get) => {
    const tpslSide = get(sideAtom);
    const leverage = get(leverageAtom);
    const side = tpslSide === 'Long' ? 'buy' : 'sell';
    const tpsl_type = tpslType === 'tp' ? 'Take Profit' : 'Stop Loss';
    const order_type =
      positionType === 'open'
        ? 'market_order'
        : isLimitOrder
          ? 'limit_order'
          : isTimeTriggerOrder
            ? 'trigger_time_order'
            : 'trigger_price_order';
    return {
      symbol,
      side,
      leverage,
      tpsl_type,
      order_type,
    };
  });

  return { commonEventPayloadAtom, tpslTabAtom };
});
tpslModalSegmentBunja.debugLabel = 'tpslModalSegmentBunja';

export const tpslModalOuterSegmentBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { commonEventPayloadAtom, tpslTabAtom } = bunja.use(tpslModalSegmentBunja);

  function trackTpslSettingTabClick(tab: 'entire' | 'partial') {
    const { tpsl_type } = store.get(commonEventPayloadAtom);
    segment.track(TradeEvent.TpslSettingTabClick, {
      view_log_name: 'tpsl_setting_view',
      view_title: tpsl_type,
      button_type: tab === 'entire' ? 'Entire' : 'Partial',
    });
  }

  function trackTpslSettingInfoClick() {
    const { tpsl_type } = store.get(commonEventPayloadAtom);
    const tab = store.get(tpslTabAtom);
    segment.track(TradeEvent.TpslSettingInfoClick, {
      view_log_name: 'tpsl_setting_view',
      view_title: tpsl_type,
      tab: tab === 'entire' ? 'Entire' : 'Partial',
    });
  }

  function trackTpslPartialBottomSheetView() {
    segment.track(TradeEvent.TpslPartialBottomSheetView, store.get(tpslPartialBottomSheetEventPayloadAtom));
  }
  function trackTpslPartialBottomSheetShowClick(isShow: boolean) {
    segment.track(TradeEvent.TpslPartialBottomSheetShowClick, {
      ...store.get(tpslPartialBottomSheetEventPayloadAtom),
      is_show: isShow,
    });
  }
  function trackTpslPartialBottomSheetConfirmClick(isShow: boolean) {
    segment.track(TradeEvent.TpslPartialBottomSheetConfirmClick, {
      ...store.get(tpslPartialBottomSheetEventPayloadAtom),
      is_show: isShow,
    });
  }

  function trackOrderPreviewEnableSlClick(enabled: boolean) {
    segment.track(TradeEvent.OrderPreviewEnableSlClick, {
      view_log_name: 'order_preview_view',
      enabled,
    });
  }

  const tpslPartialBottomSheetEventPayloadAtom = atom((get) => {
    const commonEventPayload = get(commonEventPayloadAtom);
    return commonEventPayload;
  });

  return {
    trackTpslSettingTabClick,
    trackTpslSettingInfoClick,
    trackTpslPartialBottomSheetView,
    trackTpslPartialBottomSheetShowClick,
    trackTpslPartialBottomSheetConfirmClick,
    trackOrderPreviewEnableSlClick,
  };
});
tpslModalOuterSegmentBunja.debugLabel = 'tpslModalOuterSegmentBunja';
